import React, { useEffect, useState } from "react";
import MainContentWrapper from "../../Components/MainContentWrapper";
import DashBoardCard from "../../features/HomePage/SubComponents/DashBoardCard/DashBoardCard";
import TableView from "../../ReusableComponents/TableView/TableView";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import { Button } from "../../Components/Helper";
import Filter from "../../assets/filter.svg";
import Popup from "../../ReusableFunctions/Popup";
import { getCrmleadsForAssignee } from "../../apis/BhuMeetTeams/Crm/leads";
import TeleSalesFilter from "./salesFilter";
import TabComponent from "../../features/Invoices/TabComponent";

const intervalFilterOptions = [
  {
    id: "All",
    label: "All",
  },
  {
    id: "Today",
    label: "Today",
  },
  {
    id: "Upcoming",
    label: "Upcoming",
  },
];

let activeTab = '';

const InvoicesStatCard = ({
  title,
  statNumber,
  isSelected,
  onClick,
  isDisabled,
  isArray
}) => {
  return (
    <DashBoardCard
      isDisabled={isDisabled}
      title={title}
      data={statNumber}
      onClick={onClick}
      backGround={isSelected ? "green" : undefined}
      isArray={isArray}
    />
  );
};

const InvoiceStats = ({ invoicesStats, filters, changeStatusFilter, ArrayData, userDetails }) => {
  return (
    <>
      {filters &&
        <div style={{ display: "flex", columnGap: "2%", marginBottom: "10px" }}>


          <InvoicesStatCard
            title={`All Request`}
            statNumber={invoicesStats?.total}
            isSelected={filters.Status === ""}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() =>
              changeStatusFilter({
                Status: "",
                Query: "",
                count: invoicesStats?.total,
                currentPage: 1
              })
            }
          />



          <InvoicesStatCard
            title={`Open`}
            statNumber={invoicesStats?.open_count}
            isSelected={filters.Status === "open" && userDetails.bhumeet_role != 'Telecaller'}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() => {
              changeStatusFilter({
                Status: "open",
                Query: "open",
                count: invoicesStats?.open_count,
                currentPage: 1
              })
              activeTab = filters.Status
            }
            }
          />



          <InvoicesStatCard
            title={`Close`}
            statNumber={invoicesStats?.close_count}
            isSelected={filters.Status === "close"}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() => {
              changeStatusFilter({
                Status: "close",
                Query: "close",
                count: invoicesStats?.close_count,
                currentPage: 1
              })
              activeTab = filters.Status
              }
            }
            isArray={ArrayData && filters.Status == 'close' ? ArrayData : null}
          />

          <InvoicesStatCard
            title={`Follow Up`}
            statNumber={invoicesStats?.followup_count}
            isSelected={filters.Status === "Followup"}
            isDisabled={userDetails.bhumeet_role == 'Telecaller'}
            onClick={() => {
              changeStatusFilter({
                Status: "Followup",
                Query: "Followup",
                count: invoicesStats?.close_count,
                currentPage: 1
              })
              activeTab = filters.Status
            }
            }
            isArray={ArrayData && filters.Status == 'Followup' ? ArrayData : null}
          />

        </div>}
    </>

  );
};

export const TeleCallerSalesDashBoard = () => {
  const userDetails = useSelector(state => state.user?.user)



  const navigate = useNavigate();

  // const [PageNumber, setPageNumber] = useState(1);
  const [openFilter, setOpenFilter] = useState(false);

  const [overviewData, setOverviewData] = useState({});
  const [RequestQueueData, setRequestQueueData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState(() => {
    const getFilters = localStorage.getItem("telecallerSalesFilter");
    const parsedFilters = getFilters ? JSON.parse(getFilters) : {
      fromDate: null,
      toDate: null,
      Status: "open",
      pageSize: 15,
      count: 0,
      currentPage: 1,
      Substatus: [],
      selectedCaller: "",
      searchString: "",
      state: "",
      district: "",
      taluka: "",
      target: "",
      activeInterval: "All",
    };

    return {
      ...parsedFilters,
      currentPage: 1,
      fromDate: null,
      toDate: null,
      activeInterval: "All"
    };
  });


  const [leadTabDisabled, setLeadTabDisabled] = useState(false);
  const [existingTabDisabled, setExistingTabDisabled] = useState(false);
  const [retainTabDisabled, setretainTabDisabled] = useState(false);

  useEffect(() => {
    activeTab = ""
  }, [filter.target])



  useEffect(() => {

    getTelecallers();
    localStorage.setItem("telecallerSalesFilter", JSON.stringify(filter))


  }, [filter]);



  const handleTabSwitch = async (tabType) => {
    console.log(tabType)
    if (tabType === 'lead') {
      setretainTabDisabled(true);
      setExistingTabDisabled(true)
    } else if (tabType === 'User') {
      setLeadTabDisabled(true)
      setretainTabDisabled(true)
    } else {
      setExistingTabDisabled(true)
      setLeadTabDisabled(true)
    }

    // setCurrentPage(() => 1);
    setFilter(prevFilters => ({ ...prevFilters, target: tabType, currentPage: 1, fromDate: null, toDate: null, activeInterval: "All"}));
    try {
      // await getCoupons();
      // await getCouponsStats();
    } catch (error) {
      console.error("Error fetching data:", error);
      setLeadTabDisabled(false)
      setretainTabDisabled(false)
      setExistingTabDisabled(false)
    } finally {
      // Re-enable tabs after a delay
      setTimeout(() => {
        setLeadTabDisabled(false)
        setretainTabDisabled(false)
        setExistingTabDisabled(false)
      }, 1200);
    }
  };

  const getTelecallers = () => {
    console.log("filter : ",filter)
    if (userDetails && filter != null) {
      setLoading(true);
      getCrmleadsForAssignee(
        filter
      ).then((res) => {
        // console.log(res);
        setRequestQueueData(res.leads);
        const isFollowupWithSpecificInterval = 
          filter.Status === "Followup" && 
          (filter.activeInterval === "Today" || filter.activeInterval === "Upcoming");
        
        if (isFollowupWithSpecificInterval) {
          console.log("Updating only followup count for interval filter")
          setOverviewData((prev) => ({
            ...prev,
            followup_count: res.leadCount.followup_count,
          }));
        } else {
          setOverviewData({
            total: res.leadCount.total,
            open_count: res.leadCount.open_count,
            close_count: res.leadCount.close_count,
            followup_count: res.leadCount.followup_count,
          });
        }
        setLoading(false);
      });
    }
  };

  const paginationCount = () => {
    // console.log(filter)
    if (filter.Status == '') {
      return Number(overviewData.total)
    } else if (filter.Status == 'open') {
      return Number(overviewData.open_count)
    } else if (filter.Status == 'close') {
      return Number(overviewData.close_count)
    } else if (filter.Status == 'Followup') {
      return Number(overviewData.followup_count)
    }
  }


  const handleIntervalTabChange = (interval) => {
    const today = new Date();
    const startOfToday = new Date().setHours(0, 0, 0, 0);
    const endOfToday = new Date().setHours(23, 59, 59, 999);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);
    setFilter((prev) => {
      let updatedFilter = { ...prev, activeInterval: interval, currentPage: 1 };

      switch (interval) {
        case "All":
          updatedFilter = {
            ...updatedFilter,
            fromDate: null,
            toDate: null,
          };
          break;

        case "Today":
          updatedFilter = {
            ...updatedFilter,
            fromDate: new Date(startOfToday).toISOString(),
            toDate: new Date(endOfToday).toISOString(),
          };
          break;

        case "Upcoming":
          updatedFilter = {
            ...updatedFilter,
            fromDate: tomorrow.toISOString(),
            toDate: null,
          };
          break;

        default:
          break;
      }

      return updatedFilter;
    });
  }

  return (
    <MainContentWrapper
      header={"TeleCaller Dashboard"}
      rightContent={<>
        <div style={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
          <div style={{ display: "flex", flexDirection: "row" }} className="input_field">
            <div style={{ display: "flex" }}>

              <div className="inline-flex rounded-full border border-gray-300 w-full">

                <button
                  disabled={leadTabDisabled}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${filter.target === 'lead'
                    ? 'bg-blue-100 text-blue-800 border border-[#0F5EFF]'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100'
                    }`}
                  onClick={() => handleTabSwitch("lead")}
                >
                  Lead
                </button>

                <button
                  disabled={leadTabDisabled}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${filter.target === 'User'
                    ? 'bg-blue-100 text-blue-800 border border-[#0F5EFF]'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100'
                    }`}
                  onClick={() => handleTabSwitch("User")}
                >
                  User
                </button>

                <button style={{ whiteSpace: "nowrap", width: "100%" }}
                  disabled={retainTabDisabled}
                  type="button"
                  className={`px-4 py-2 text-sm rounded-full transition-colors w-1/2 ${filter.target === 'To Retain'
                    ? 'bg-blue-100 text-blue-800 border border-[#0F5EFF]'
                    : 'bg-transparent text-gray-700 hover:bg-gray-100'
                    }`}
                  onClick={() => handleTabSwitch("To Retain")}
                >
                  To Retain
                </button>
              </div>
            </div>

          </div>

          <div style={{
            display: "flex",
            justifyContent: "space-between",
            gap: "5px"
          }}>



            <Button
              innerClassName={"filter-btn-inner"}
              iconStyle={{ width: "18px", marginRight: "10px" }}
              text={"Filter"}
              icon={Filter}
              className={"filter-btn"}
              onClick={() => {
                setOpenFilter(true)
              }}

            />
          </div>

        </div>


      </>}
    >
      {openFilter &&
        <TeleSalesFilter
          filter={filter}
          onFilterChange={(filter) => {

            setOpenFilter(false)
            setFilter(filter)

          }}
          onClose={() => setOpenFilter(false)}
          open={openFilter}
        />
      }
      <InvoiceStats
        invoicesStats={overviewData}
        filters={filter}
        userDetails={userDetails}
        // ArrayData = {callHistoryOverview}
        changeStatusFilter={(statusFiler) => {
          const isLeavingFollowup = filter.Status === "Followup" && statusFiler.Status !== "Followup";
          const isEnteringFollowup = filter.Status !== "Followup" && statusFiler.Status === "Followup";

          const shouldClearDates = isLeavingFollowup || isEnteringFollowup;

          setFilter({
            ...filter,
            count: statusFiler.count,
            Status: statusFiler.Status,
            currentPage: statusFiler.currentPage,
            ...(shouldClearDates
              ? {
                fromDate: null,
                toDate: null,
                activeInterval: "All",
              }
              : {}),
          });
        }}
      />

      <div className="flex p-2">
        {filter.Status === "Followup" && (
          <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: "10px" }}>
            <TabComponent
              tabData={intervalFilterOptions}
              activeTab={filter?.activeInterval}
              onTabChange={(interval) => {
                handleIntervalTabChange(interval);
              }}
            />
          </div>
        )}
      </div>
      <TableView
        showSrNo={true}
        onStateChange={async (changedState) => {
          const { pageNumber } = changedState;
          // console.log(changedState);
          setFilter({ ...filter, currentPage: pageNumber })
          // console.log("PAge Nam",filter.currentPage)


        }}
        onClickRow={(row) => {
          if (row.queue_status == 'open' || row.queue_status == 'Followup') {

            navigate(row.target == 'lead' || row.target == 'To Retain' ? '/crm/leads/detail' : `/userDetails`, { state: row.target === 'lead' || row.target === 'To Retain' ? { ...row, showFollowUp: row.queue_status === "close" ? false : true, showCreatedOrder: row.queue_status === "close" ? false : true } : { user: { ...row.user, campaign_id: row.campaign_id, crm: true, showCreatedOrder: true } } }
            );

          } else {
            return Popup.alert("ERROR", "This lead is already closed", "ERROR")
          }

        }}
        isLoading={loading}
        tableContainerHeight={"75%"}
        loaderHeight={"500px"}
        columns={[
          { Header: "Campaign Name", accessor: "name", width: "15%" },

          { Header: "Campaign Type", accessor: "showType", width: "10px" },
          { Header: "Campaign Target", accessor: "target" },
          { Header: "lead Name", accessor: "lead_name" },
          ...(filter.Status == 'close' ? [{ Header: "Last Note", accessor: "last_note" }] : []),
          { Header: "Status", accessor: "statusToShown" },
          ...(filter.Status != 'Followup' ? [{ Header: "Call Assigned", accessor: "queue_created", isDate: true }] : []),
          ...(filter.Status == 'Followup' ? [{ Header: "Follow Up", accessor: "queue_created", isDate: true }] : []),
        ]}
        data={RequestQueueData?.map((leaddetails) => {
          return {
            ...leaddetails,
            statusToShown: leaddetails?.queue_status === "Followup" ? "Follow Up" : leaddetails?.queue_status,
            showType: leaddetails?.type === "Auto_IVR" ? "Auto IVR" : leaddetails?.type
          }
        })}
        pageNumber={filter.currentPage ?? 1}
        pageSize={15}
        count={paginationCount() || 0}

      // activities={{ onClickDelete: (coupon) => Popup.alert("WARNING", "Are you sure , you want to delete this coupon?", "WARNING", () => deleteCoupon(coupon)), onClickEdit: onEdit, canEdit: true }}
      />
    </MainContentWrapper>
  );
};
